import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { getPicklist, getPicklists, updatePicklistItems } from '@lingaai/supabase-client';
import type { PicklistItem } from '@lingaai/supabase-client';

/**
 * Hook to get a single picklist by name
 */
export function usePicklist(name: string) {
  return useQuery({
    queryKey: ['picklist', name],
    queryFn: () => getPicklist(name),
    enabled: !!name,
  });
}

/**
 * Hook to get all picklists for the current tenant
 */
export function usePicklists() {
  return useQuery({
    queryKey: ['picklists'],
    queryFn: () => getPicklists(),
  });
}

/**
 * Hook to update picklist items
 */
export function useUpdatePicklistItems() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ name, items }: { name: string; items: PicklistItem[] }) => updatePicklistItems(name, items),
    onSuccess: (data, variables) => {
      if (data) {
        queryClient.invalidateQueries({ queryKey: ['picklist', data.name] });
      } else {
        queryClient.invalidateQueries({ queryKey: ['picklist', variables.name] });
      }
      queryClient.invalidateQueries({ queryKey: ['picklists'] });
    },
  });
}
